import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody } from "reactstrap"

const PopupModal = ({ show, title, message, orderId }) => {
  return (
    <Modal size="md" isOpen={show} centered={true}>
      <div className="modal-content" >
        <ModalBody className="px-4 py-5 text-center">
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi ">{title}</i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">{message} <a target="_blank" rel="noreferrer" href={"/orders/edit/"+orderId}>Click to view</a></p>

        </ModalBody>
      </div>
    </Modal>
  )
}

PopupModal.propTypes = {
  show: PropTypes.any,
  title: PropTypes.any,
  message: PropTypes.any
}

export default PopupModal;
